import type {EmailMakerSectorVisibilityCtx} from '../../right-panel-registry.types';

/** Shared variant class for inline warning info boxes (trimmed gif/video, read-only footer). */
export const WARNING_INFO_BOX_VARIANT_CLASS = '-warning no-vertical-margin' as const;

/** Gates AI prompt rows (button/text rewrite, wrapper redesign) on the editor's AI text-generation flag. */
export function isAiTextEnabled(ctx: EmailMakerSectorVisibilityCtx): boolean {
  return ctx.store.isEmailEditorAiTextGenerationEnabled;
}
